import { gql } from '@apollo/client/core';

export const DELETE_PROGRAMME_REPORTER_ASSIGNEE = gql`
  mutation DeleteProgrammeReporterAssignee($input: DeleteProgrammeReporterAssigneeInput!) {
    programmeReporter: deleteProgrammeReporterAssignee(input: $input) {
      id
    }
  }
`;
